import { render } from "./ThongTinGiayTo.vue?vue&type=template&id=2c26e148"
import script from "./ThongTinGiayTo.vue?vue&type=script&lang=js"
export * from "./ThongTinGiayTo.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__